import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { Occupation, Profile, UserId } from './profile.model';
import { Member } from './member.model';
import { LogService } from '../../services/log.service';
import { LimitedMember } from '../../models/limited-member';

@Injectable({ providedIn: 'root' })
export class OccupationService {
  apiHost: string = environment.apiHost;

  constructor(
    private http: HttpClient,
    private router: Router,
    private logService: LogService
  ) {}

  getOccupationList(): Promise<Occupation[]> { 
    let promise = new Promise<Occupation[]>((resolve, reject) => {
      return this.http
        .get<Occupation[]>(this.apiHost + '/user/getOccupations') 
        .toPromise()
        .then(
          (data) => {
            resolve(data);  
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Profile', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }
}
